import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ShHeadersService {
  static getAccessControlDevelopment: string =
    'app.dev.apilab.bancodelaustro.com';
  static getAccessControlStaging: string = 'app.dev.apilab.bancodelaustro.com';
  static getAccessControlProduction: string =
    'credivehiculos.bancodelaustro.com';
  static tokenDevelopment: string =
    '91qgqmJrlujxGkMGScj9y9ZyQHgUfoUDt3cXsgdud8kD26PTFmYtzVcDvv2iPlEc0sfxYfcruZuBMNQeXF7iKUlfHYnMEDK4VnOu3PTysCgL2RrQlMN6l5dkcB5UdfHd';
  static tokenStaging: string =
    '91qgqmJrlujxGkMGScj9y9ZyQHgUfoUDt3cXsgdud8kD26PTFmYtzVcDvv2iPlEc0sfxYfcruZuBMNQeXF7iKUlfHYnMEDK4VnOu3PTysCgL2RrQlMN6l5dkcB5UdfHd';
  static tokenProduction: string =
    '91qgqmJrlujxGkMGScj9y9ZyQHgUfoUDt3cXsgdud8kD26PTFmYtzVcDvv2iPlEc0sfxYfcruZuBMNQeXF7iKUlfHYnMEDK4VnOu3PTysCgL2RrQlMN6l5dkcB5UdfHd';

  constructor() {}

  buildHeaders(params: any, envHeaders: any, flowUser?: string) {
    let idclient =
      params.control[0] && params.control[0].data && params.control[0].data.id
        ? params.control[0].data.id
        : '';
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('userapp', 'SELLERCREDIVEHICULOS')
      .set('channel', 'AWS')
      .set('idclient', idclient)
      .set('idlogin', params.userapp)
      .set('operation', params.operation)
      .set('process', params.process || params.session)
      .set('session', params.session);

    if (envHeaders.setIdSeller !== 'NO') {
      headers = headers.set('idseller', params.userapp);
    }

    if (envHeaders.setHeadersOffer === 'YES') {
      headers = headers.set('qualification', envHeaders.typeApplicant);
      headers = headers.set('offerNumber', envHeaders.offerNumber);
    }

    if (flowUser) {
      headers = headers.set('flow-user', flowUser);
    }
    return headers;
  }

  buildBody(params: any) {
    return {
      control: params.control,
    };
  }
}
